var PageWidgetCtrl = function($scope, OfficeModel, office, gettextCatalog, Notification) {
  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
  this.office = office;
  this.widgetHtmlCode = this.getWidgetCode();
  this._OfficeModel = OfficeModel;
  this._Notification = Notification;
  this.gettextCatalog = gettextCatalog;
  this._init();
  this.stringOverwrites = {
    select_services: gettextCatalog.getString('Select your services'),
    services: gettextCatalog.getString('services'),
    appointment: gettextCatalog.getString('appointment'),
    contact: gettextCatalog.getString('contact'),
    forward: gettextCatalog.getString('forward'),
    back: gettextCatalog.getString('back'),
    book_appointment: gettextCatalog.getString('book appointment'),
    congratulations: gettextCatalog.getString(
      'Congratulations! You successfully booked an appointment. Please await the appointment confirmation from the service provider.',
    ),
    check_spam: gettextCatalog.getString('Please also check your spam folder emails!'),
    book_another_appointment: gettextCatalog.getString(
      'Book another appointment at {{SuccessCtrl.office.name}}',
    ),
  };
};

PageWidgetCtrl.prototype._init = function() {
  if (
    !this.office.settings.widget ||
    !this.office.settings.widget.appointment ||
    !this.office.settings.widget.appointment.primary ||
    !this.office.settings.widget.appointment.primaryContrast
  ) {
    this.revert();
  }
};

PageWidgetCtrl.prototype.getWidgetCode = function() {
  var widgetCode =
    '<iframe src="https://www.termin2go.com/appointment-booking/' +
    this.office.slug +
    '#/services?channel=web" frameBorder="0" height="560px" width="100%" scrolling="yes"></iframe>';
  return widgetCode;
};

PageWidgetCtrl.prototype.save = function() {
  var self = this;
  this._OfficeModel.update(this.office, function(error) {
    if (error) {
      self._Notification.addErrorMessage({ text: error });
    } else {
      self._Notification.addSuccessMessage(self.gettextCatalog.getString('Widget settings saved'));
    }
  });
};

PageWidgetCtrl.prototype.revert = function() {
  this.office.settings.widget = {
    appointment: {
      bg: '#FFFFFF',
      primary: '#4CAF50',
      primaryContrast: '#FFFFFF',
    },
  };
};

PageWidgetCtrl.prototype.resetString = function(key) {
  this.office.settings.widget.appointment.text[key] = '';
};

module.exports = PageWidgetCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/pageWidget/pageWidgetCtrl.js